import { XMAX_OPEN_API_PRODUCTION_BASE_URL, XmaxOpenClient } from '../api/client'
import { createFileClient } from '../files/client'
import { createRealtimeClient } from '../realtime/client'
import {
  createOfflineClient,
  XMAX_OFFLINE_API_PRODUCTION_BASE_URL,
} from '../offline/client'
import { createSDKI18n } from '../i18n'
import type { XmaxClient, XmaxClientOptions } from './types'

function resolveClientOptions(
  options: XmaxClientOptions,
): Required<Pick<XmaxClientOptions, 'baseUrl' | 'offlineBaseUrl'>> & XmaxClientOptions {
  return {
    ...options,
    baseUrl: options.baseUrl?.trim() || XMAX_OPEN_API_PRODUCTION_BASE_URL,
    offlineBaseUrl: options.offlineBaseUrl?.trim() || XMAX_OFFLINE_API_PRODUCTION_BASE_URL,
  }
}

export function createXmaxClient(options: XmaxClientOptions): XmaxClient {
  const resolved = resolveClientOptions(options)
  const i18n = resolved.i18n ?? createSDKI18n({ locale: resolved.locale })
  const resolvedWithI18n = { ...resolved, i18n }
  const httpClient = new XmaxOpenClient({
    apiKey: resolved.apiKey,
    authToken: resolved.authToken,
    baseUrl: resolved.baseUrl,
    i18n,
    onError: resolved.onError,
    telemetry: resolved.telemetry,
    reportSource: resolved.reportSource,
  })
  const offlineHttpClient = new XmaxOpenClient({
    apiKey: resolved.apiKey,
    authToken: resolved.authToken,
    baseUrl: resolved.offlineBaseUrl,
    i18n,
    onError: resolved.onError,
    telemetry: resolved.telemetry,
    reportSource: resolved.reportSource,
  })
  const files = createFileClient(httpClient)

  return {
    files,
    realtime: createRealtimeClient(resolvedWithI18n),
    offline: createOfflineClient(offlineHttpClient, files, {
      i18n,
      onError: resolved.onError,
    }),
  }
}
